/**
 * Reine Hilfen der Karte „Versände der letzten Woche" (Workshop-Lücke N4, Plan 2026-10-29). Getestet in `rueckblick.test.ts`.
 */

/** `2026-W43` + Montag/Montag danach → „KW 43 · 19.10.–25.10.2026". */
export function wochenText(woche: string, von: string, bisExklusiv: string): string {
  const [j, m, t] = bisExklusiv.split('-').map(Number);
  const sonntag = new Date(Date.UTC(j, m - 1, t - 1)).toISOString().slice(0, 10);
  const kw = Number(woche.slice(-2));
  return `KW ${kw} · ${von.slice(8, 10)}.${von.slice(5, 7)}.–${sonntag.slice(8, 10)}.${sonntag.slice(5, 7)}.${sonntag.slice(0, 4)}`;
}

/** Abweichung in Prozent gegen den Vergleich; null, wenn einer fehlt oder der Vergleich 0 ist. */
export function abweichung(jetzt: number | null | undefined, vergleich: number | null | undefined): number | null {
  if (jetzt === null || jetzt === undefined || vergleich === null || vergleich === undefined || vergleich <= 0) return null;
  return (jetzt / vergleich - 1) * 100;
}

/** Spanne der Alter (Tage) einer Fläche: „3–9 Tage", ein Wert „4 Tage", ohne Versand „—". */
export function alterSpanne(alter: number[]): string {
  if (alter.length === 0) return '—';
  const min = Math.min(...alter);
  const max = Math.max(...alter);
  return min === max ? `${min} ${min === 1 ? 'Tag' : 'Tage'}` : `${min}–${max} Tage`;
}

/** Feste Reihenfolge der Wellen beim Sortieren. */
export const WELLEN_RANG: Record<'vortag' | 'frueh' | 'spaet', number> = { vortag: 1, frueh: 2, spaet: 3 };
